import { render, staticRenderFns } from "./AssignSmarttruck.vue?vue&type=template&id=b71998c4&"
import script from "./AssignSmarttruck.vue?vue&type=script&lang=js&"
export * from "./AssignSmarttruck.vue?vue&type=script&lang=js&"
import style0 from "./AssignSmarttruck.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports